import { render, staticRenderFns } from "./indications-history-icon-box.vue?vue&type=template&id=72a70c08&scoped=true"
import script from "./indications-history-icon-box.vue?vue&type=script&lang=js"
export * from "./indications-history-icon-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a70c08",
  null
  
)

export default component.exports